import type { RotasDoModulo } from '@/app/rotas';

import { BureauConsultationsPage } from './BureauConsultationsPage';
import { IntegrationsPage } from './IntegrationsPage';

/** Integracoes: provedores e registro de chamadas, e as consultas a bureau. */
export const rotas: RotasDoModulo = {
  menu: {
    '/integracoes': IntegrationsPage,
    '/consultas-bureau': BureauConsultationsPage,
  },
};
